<template>
    <div>
        <b-form-group
            label="Question"
            label-for="question"
        >

            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
                @input="setContent('question', $event)"
            />

            <b-form-invalid-feedback :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
            label="Image"
            label-for="image"
        >

            <b-form-invalid-feedback class="mb-2" :state="validating && (!editable_content.image || editable_content.image && !editable_content.image.src) ? false : null">
                Image is required
            </b-form-invalid-feedback>

            <div class="row">
                <div :class="{'col-6': editable_content.image && editable_content.image.src, 'col-12': !editable_content.image || editable_content.image && !editable_content.image.src}">
                    <div v-show="editable_content.image">
                        <div v-if="editable_content.image && editable_content.image.src" class="node-actions m-2">
                            <b-btn size="sm" variant="primary" class="edit mr-1" @click.prevent="edit(null)">
                                <font-awesome-icon :icon="['far', 'edit']" />
                            </b-btn>
                            <b-btn size="sm" variant="danger" @click.prevent="removeImage">
                                <font-awesome-icon :icon="['fad', 'trash']" />
                            </b-btn>
                        </div>
                        <div class="mb-2 position-relative" :class="{'merlin-asset-border': editable_content.image && isMerlinMedia(editable_content.image.src)}">
                            <div v-if="isMerlinMedia(editable_content.image.src)" class="merlin-asset-wrapper">
                                <span class="merlin-asset-warning">
                                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                    Merlin Asset
                                </span>
                            </div>
                            <b-img
                                ref="image"
                                :src="editable_content.image ? editable_content.image.src : ''"
                                fluid
                                @click.prevent="addLabel($event)"
                            />
                            <div v-for="(label, index) in editable_content.labels" :key="index">
                                <a href="#" class="badge badge-warning rounded" v-tack:top="label.dot.offsetY - 13" v-tack:left="label.dot.offsetX - 13" @click.prevent="focusLabel(label, index)">
                                    {{index + 1}}
                                </a>
                            </div>
                        </div>
                        <div class="related-media-id">
                            <span v-if="editable_content.image.related_media_id"> <b>Media ID:</b> {{ editable_content.image.related_media_id }} </span>
                            <span v-if="editable_content.image.merlin_id"> <b>Merlin ID:</b> {{ editable_content.image.merlin_id }} </span>
                            <span v-if="editable_content.image.description"> <b>Description:</b> {{editable_content.image.description}} </span>
                            <span v-if="editable_content.image.alt"> <b>ALT:</b> {{editable_content.image.alt}} </span>
                            <span v-if="editable_content.image.caption"> <b>Caption:</b> {{editable_content.image.caption}} </span>
                            <span v-if="editable_content.image.credit"> <b>Credit:</b> {{editable_content.image.credit}} </span>
                        </div>

                        <div class="d-flex">
                            <div>
                                <b-dropdown
                                    size="sm"
                                    variant="outline-primary"
                                    dropup
                                    right
                                >
                                    <template #button-content>
                                        <font-awesome-icon :icon="['fad', 'plus-square']" /> Select Background Image
                                    </template>
                                    <b-dropdown-item @click.prevent="addExistingRelatedMedia">
                                        <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width /> Add SBP Media Image
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="editable_content.image && editable_content.image.src" class="col-6">

                    <b-form-group
                        label="Labels"
                    >
                        <b-form-group

                        >
                            <div
                                v-for="(label, index) in editable_content.labels"
                                :key="index"
                                class="mb-2"
                            >
                                <b-input-group>
                                    <b-input-group-prepend is-text>
                                        <span
                                            class="merlin-asset-small"
                                            v-if="label.type != 'text' && isMerlinMedia(label.url)"
                                            content="Merlin Asset"
                                            v-tippy="{placement: 'top'}"
                                        >
                                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                        </span>
                                        {{index + 1}}
                                    </b-input-group-prepend>
                                    <b-input-group-prepend v-if="!label.type || label.type != 'text'">
                                        <div
                                            :id="`edit-popover-${label.url}`"
                                            :style="{
                                            height: '50px',
                                            'max-height': '50px'}">
                                            <b-img
                                                ref="label.url"
                                                :src="label.url"
                                                fluid
                                                class="image-label"
                                            />
                                        </div>
                                        <div>
                                            <b-popover :target="`edit-popover-${label.url}`" triggers="hover" placement="top" class="mt-2">
                                                <div class="node-actions m-2">
                                                    <b-btn size="sm" variant="primary" class="edit mr-1" @click.prevent="edit('label', index)">
                                                        <font-awesome-icon :icon="['far', 'edit']" />
                                                    </b-btn>
                                                    <b-btn size="sm" variant="danger" @click.prevent="removeLabelImage(index)">
                                                        <font-awesome-icon :icon="['fad', 'trash']" />
                                                    </b-btn>
                                                </div>
                                            </b-popover>
                                        </div>
                                    </b-input-group-prepend>

                                    <b-form-input
                                        :ref="'label' + index"
                                        v-model="label.text"
                                        :state="validating && (!label.text && !label.url) ? false : null"
                                        v-focus
                                        v-if="!label.type || label.type == 'text'"
                                        :style="{
                                            height: '50px',
                                            'max-height': '50px'}"
                                    />
                                    <b-form-input
                                        :ref="'label' + index"
                                        v-model="label.url"
                                        :state="validating && (!label.text && !label.url) ? false : null"
                                        v-focus
                                        v-else
                                        :disabled="true"
                                        :style="{
                                            height: '50px',
                                            'max-height': '50px'}"
                                    />

                                    <b-input-group-append>
                                        <b-dropdown
                                            size="sm"
                                            variant="info"
                                            dropup
                                            right
                                        >
                                            <template #button-content>
                                                <font-awesome-icon :icon="['far', 'image']" />
                                            </template>
                                            <b-dropdown-item @click.prevent="addSBPImageToLabel(index)">
                                                <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width /> Add SBP Media Image
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </b-input-group-append>

                                    <b-input-group-append>
                                        <b-btn variant="danger" @click="deleteLabel(index)">
                                            <font-awesome-icon :icon="['far', 'minus']" />
                                        </b-btn>
                                    </b-input-group-append>
                                </b-input-group>

                                <b-form-invalid-feedback class="mb-2" :state="validating && (!label.text && !label.url) ? false : null">
                                    Text is required
                                </b-form-invalid-feedback>
                            </div>

                            <b-alert
                                variant="danger"
                                :show="!editable_content.labels || editable_content.labels && !editable_content.labels.length"
                                class="mb-0"
                            >
                                0 Labels
                            </b-alert>

                            <b-form-invalid-feedback
                                class="mt-2"
                                :state="validating && (!editable_content.labels || editable_content.labels && !editable_content.labels.length) ? false : null"
                            >
                                At least 1 label is required
                            </b-form-invalid-feedback>

                        </b-form-group>

                    </b-form-group>

                    <b-form-group
                        label="Incorrect Clues"
                        class="mb-0"
                    >
                        <div
                            v-for="(clue, index) in editable_content.incorrect_clues"
                            :key="index"
                            class="mb-2"
                        >
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                        <span
                                            class="merlin-asset-small"
                                            v-if="clue.type != 'text' && isMerlinMedia(clue.url)"
                                            content="Merlin Asset"
                                            v-tippy="{placement: 'top'}"
                                        >
                                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                        </span>
                                    {{index + 1}}
                                </b-input-group-prepend>
                                <b-input-group-prepend v-if="!clue.type || clue.type != 'text'">
                                    <div
                                        :id="`edit-popover-${clue.url}`"
                                        :style="{
                                        height: '50px',
                                        'max-height': '50px'}">
                                        <b-img
                                            ref="clue.url"
                                            :src="clue.url"
                                            fluid
                                            class="image-clue"
                                        />
                                    </div>
                                    <div>
                                        <b-popover :target="`edit-popover-${clue.url}`" triggers="hover" placement="top" class="mt-2">
                                            <div class="node-actions m-2">
                                                <b-btn size="sm" variant="primary" class="edit mr-1" @click.prevent="edit('clue', index)">
                                                    <font-awesome-icon :icon="['far', 'edit']" />
                                                </b-btn>
                                                <b-btn size="sm" variant="danger" @click.prevent="removeClueImage(index)">
                                                    <font-awesome-icon :icon="['fad', 'trash']" />
                                                </b-btn>
                                            </div>
                                        </b-popover>
                                    </div>
                                </b-input-group-prepend>

                                <b-form-input
                                    :ref="'incorrect_clue' + index"
                                    v-model="clue.text"
                                    :state="validating && (!clue.text && !clue.url) ? false : null"
                                    v-focus
                                    v-if="!clue.type || clue.type == 'text'"
                                    :style="{
                                        height: '50px',
                                        'max-height': '50px'}"
                                />
                                <b-form-input
                                    :ref="'incorrect_clue' + index"
                                    v-model="clue.url"
                                    :state="validating && (!clue.text && !clue.url) ? false : null"
                                    v-focus
                                    v-else
                                    :disabled="true"
                                    :style="{
                                        height: '50px',
                                        'max-height': '50px'}"
                                />

                                <b-input-group-append>
                                    <b-dropdown
                                        size="sm"
                                        variant="info"
                                        dropup
                                        right
                                    >
                                        <template #button-content>
                                            <font-awesome-icon :icon="['far', 'image']" />
                                        </template>
                                        <b-dropdown-item @click.prevent="addSBPImageToIncorrectClue(index)">
                                            <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width /> Add SBP Media Image
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-input-group-append>

                                <b-input-group-append>
                                    <b-btn variant="danger" @click="deleteIncorrectClue(index)">
                                        <font-awesome-icon :icon="['far', 'minus']" />
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>

                            <b-form-invalid-feedback class="mb-2" :state="validating && (!clue.text && !clue.url) ? false : null">
                                Text is required
                            </b-form-invalid-feedback>
                        </div>

                        <b-alert
                            variant="warning"
                            :show="!editable_content.incorrect_clues || editable_content.incorrect_clues && !editable_content.incorrect_clues.length"
                            class="mb-2"
                        >
                            0 Incorrect Clues
                        </b-alert>

                    </b-form-group>
                    <b-btn size="sm" variant="outline-primary" @click="addIncorrectClue">
                        <font-awesome-icon :icon="['fad', 'plus-square']" /> Add Incorrect Clue
                    </b-btn>
                </div>
            </div>
        </b-form-group>

        <related-media-item-modal
            v-model="show_related_media_item_modal"
            :item="computedImage"
            @update="update"
            @hide="show_related_media_item_modal = false"
        />

        <related-media-item-modal
            v-model="show_related_media_label_item_modal"
            :item="activeLabel"
            @update="updateLabel($event, activeLabel, activeLabelIndex)"
            @hide="show_related_media_label_item_modal = false"
        />

        <related-media-item-modal
            v-model="show_related_media_clue_item_modal"
            :item="activeClue"
            @update="updateClue($event, activeClue, activeClueIndex)"
            @hide="show_related_media_clue_item_modal = false"
        />

        <add-related-media-modal
            v-model="show_add_related_media_modal"
            :type="'image'"
            @link="linkRelatedMediaItem"
            @hide="show_add_related_media_modal = false"
        />

    </div>
</template>

<style lang="scss" scoped>
.related-media-id {
    font-size: 80%;
    bottom: 1rem;
    left: 5px;
    margin-bottom: 1rem;
    background: white;
}
.image-clue, .image-label {
    max-height: 100%;
    max-width: 100%;
    height: auto;
}
</style>

<script>
import { mapState } from 'vuex'

import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal'
import RelatedMediaItemModal from '@/components/modals/article/related_media/RelatedMediaItemModal'

export default {
    data: () => ({
        editable_content: {
            image: {},
            labels: [],
            incorrect_clues: []
        },
        activeLabel: {},
        activeLabelIndex: 0,
        activeClue: {},
        activeClueIndex: 0,
        show_add_related_media_modal: false,
        show_related_media_item_modal: false,
        show_related_media_label_item_modal: false,
        show_related_media_clue_item_modal: false,
    }),
    props: [
        'question'
    ],
    directives: {
        tack: {
            bind (el, binding) {
            el.style.position = 'absolute'
            const s = (binding.arg == 'left' ? 'left' : 'top')
            el.style[s] = binding.value + 'px'
            },
            update (el, binding) {
                el.style.position = 'absolute'
                const s = (binding.arg == 'left' ? 'left' : 'top')
                el.style[s] = binding.value + 'px'
            },
            unbind (el) {
                el.style = null
            }
        }
    },
    components: {
        TipTap: () => import('@/components/tiptap/TipTap'),
        AddRelatedMediaModal,
        RelatedMediaItemModal
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        }),
        computedImage() {
            // Prevents an issue where we have an image, but its type is not set for the RelatedMediaItemModal.
            let image = this.editable_content.image
            if (image) {
                image.type = image.type ? image.type : 'image'
            }

            return image
        },
    },
    watch: {
        question: {
            handler (question) {
                if (
                    question &&
                    question.content
                ) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    if (
                        this.$refs.image
                    ) {
                        if (
                            (this.$refs.image.height && !editable_content.image.height) ||
                            (this.$refs.image.height && editable_content.image.height && this.$refs.image.height !== editable_content.image.height)
                        ) {
                            editable_content.image.height = this.$refs.image.height
                        }
                        if (
                            (this.$refs.image.width && !editable_content.image.width) ||
                            (this.$refs.image.width && editable_content.image.width && this.$refs.image.width !== editable_content.image.width)
                        ) {
                            editable_content.image.width = this.$refs.image.width
                        }
                    }

                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        edit (type, index) {
            if (type == 'label') {
                this.activeLabel = this.editable_content.labels[index]
                this.activeLabelIndex = index
                this.show_related_media_label_item_modal = true
            } else if (type == 'clue') {
                this.activeClue = this.editable_content.incorrect_clues[index]
                this.activeClueIndex = index
                this.show_related_media_clue_item_modal = true
            } else {
                this.show_related_media_item_modal = true
            }
        },
        addLabel ($event) {
            if (!this.editable_content.labels) {
                this.$set(this.editable_content, "labels", [])
            }

            this.editable_content.labels.push({
                dot: {
                    offsetY: $event.offsetY,
                    offsetX: $event.offsetX,
                },
                text: null,
                type: 'text',
                url: null,
            })
		},
        focusLabel (label, index) {
            if (this.$refs['label' + index]) {
                this.$refs['label' + index][0].focus()
            }
		},
        deleteLabel (index) {
            if (this.editable_content.labels) {
                this.editable_content.labels.splice(index, 1)
            }
        },
        addIncorrectClue () {
            if (!this.editable_content.incorrect_clues) {
                this.$set(this.editable_content, "incorrect_clues", [])
            }

            this.editable_content.incorrect_clues.push({
                type: 'text',
                text: null,
                url: null,
            })
        },
        deleteIncorrectClue (index) {
            if (this.editable_content.incorrect_clues) {
                this.editable_content.incorrect_clues.splice(index, 1)
            }
        },
        removeImage() {
            this.$swal({
                html: 'Are you sure you want remove the background image? If you proceed, all labels will be lost.',
                showCancelButton: true,
                confirmButtonText: 'Remove Image',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.$set(this.editable_content, 'image', {})
                    this.$set(this.editable_content, 'labels', [])
                    this.$set(this.editable_content, 'incorrect_clues', [])
                }
            })
        },
        removeLabelImage(index) {
            this.$swal({
                html: 'Are you sure you want remove the label image? This will set it back to a blank text label',
                showCancelButton: true,
                confirmButtonText: 'Remove Label Image',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    // save the label coordinates, but then set to empty text label
                    const labelDots = this.editable_content.labels[index].dot;
                    this.$set(this.editable_content.labels, index, {})
                    this.$set(this.editable_content.labels[index], 'dot', labelDots);
                    this.$set(this.editable_content.labels[index], 'text', null);
                    this.$set(this.editable_content.labels[index], 'type', 'text');
                    this.$set(this.editable_content.labels[index], 'url', null);
                }
            })
        },
        removeClueImage(index) {
            this.$swal({
                html: 'Are you sure you want remove the clue image? This will set it back to a blank text clue',
                showCancelButton: true,
                confirmButtonText: 'Remove Clue Image',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.$set(this.editable_content.incorrect_clues, index, {});
                    this.$set(this.editable_content.incorrect_clues[index], 'text', null);
                    this.$set(this.editable_content.incorrect_clues[index], 'type', 'text');
                    this.$set(this.editable_content.incorrect_clues[index], 'url', null);
                }
            })

        },
        update (media) {
            let imageClone = Object.assign({}, this.editable_content.image)
            if (media.merlin_id) {
                let merlinId = parseInt(media.merlin_id)
                imageClone.merlin_id = !isNaN(merlinId) ? merlinId : null
                imageClone.media_id = !isNaN(merlinId) ? merlinId : null
            } else if (media.related_media_id) {
                let mediaId = parseInt(media.related_media_id)
                imageClone.related_media_id = !isNaN(mediaId) ? mediaId : null
                imageClone.media_id = !isNaN(mediaId) ? mediaId : null
            }
            imageClone.type = media.type
            imageClone.src = media.src
            imageClone.alt = media.alt
            imageClone.credit = media.credit
            imageClone.description = media.description
            imageClone.caption = media.caption
            imageClone.name = media.name ? media.name : (media.title ? media.title : '')

            // If there were new properties added, re-setting the image field will ensure Vue reacts to them.
            this.$set(this.editable_content, 'image', imageClone)
        },
        updateLabel (media, label, index) {
            let labelClone = Object.assign({}, label)
            if (media.merlin_id) {
                let merlinId = parseInt(media.merlin_id)
                labelClone.merlin_id = !isNaN(merlinId) ? merlinId : null
                labelClone.media_id = !isNaN(merlinId) ? merlinId : null
            } else if (media.related_media_id) {
                let mediaId = parseInt(media.related_media_id)
                labelClone.related_media_id = !isNaN(mediaId) ? mediaId : null
                labelClone.media_id = !isNaN(mediaId) ? mediaId : null
            }
            labelClone.type = media.type
            labelClone.src = media.src
            labelClone.alt = media.alt
            labelClone.credit = media.credit
            labelClone.description = media.description
            labelClone.caption = media.caption
            labelClone.name = media.name ? media.name : (media.title ? media.title : '')

            // If there were new properties added, re-setting the label will ensure Vue reacts to them.
            this.$set(this.editable_content.labels, index, labelClone)
        },
        updateClue (media, clue, index) {
            let clueClone = Object.assign({}, clue)
            if (media.merlin_id) {
                let merlinId = parseInt(media.merlin_id)
                clueClone.merlin_id = !isNaN(merlinId) ? merlinId : null
                clueClone.media_id = !isNaN(merlinId) ? merlinId : null
            } else if (media.related_media_id) {
                let mediaId = parseInt(media.related_media_id)
                clueClone.related_media_id = !isNaN(mediaId) ? mediaId : null
                clueClone.media_id = !isNaN(mediaId) ? mediaId : null
            }
            clueClone.type = media.type
            clueClone.src = media.src
            clueClone.alt = media.alt
            clueClone.credit = media.credit
            clueClone.description = media.description
            clueClone.caption = media.caption
            clueClone.name = media.name ? media.name : (media.title ? media.title : '')

            // If there were new properties added, re-setting the clue will ensure Vue reacts to them.
            this.$set(this.editable_content.incorrect_clues, index, clueClone)
        },
        setContent (field, value) {
            this.$set(this.editable_content, field, value)
        },
        addExistingRelatedMedia(){
            if (
                this.editable_content.image &&
                this.editable_content.image.src
            ) {
                this.$swal({
                    html: 'Are you sure you want select a different image? If you proceed, all labels will be lost.',
                    showCancelButton: true,
                    confirmButtonText: 'Select Different Image',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.show_add_related_media_modal = true
                    }
                })
            } else {
                this.show_add_related_media_modal = true;
            }
        },
        linkRelatedMediaItem(item){
            if(this.linking_to_label){
                this.editable_content.labels[this.linking_to_label_index].type = 'image',
                this.editable_content.labels[this.linking_to_label_index].title = item.title,
                this.editable_content.labels[this.linking_to_label_index].credit = item.credit
                this.editable_content.labels[this.linking_to_label_index].description = item.description
                this.editable_content.labels[this.linking_to_label_index].caption = item.caption
                this.editable_content.labels[this.linking_to_label_index].url = item.url,
                this.editable_content.labels[this.linking_to_label_index].alt = item.alt
                this.editable_content.labels[this.linking_to_label_index].related_media_id = item.id

                this.linking_to_label_index = 0;
                this.linking_to_label = false;
                this.show_add_related_media_modal = false;
            }
            else if (this.linking_to_incorrect_clue) {
                this.editable_content.incorrect_clues[this.linking_to_label_index].type = 'image',
                this.editable_content.incorrect_clues[this.linking_to_label_index].title = item.title,
                this.editable_content.incorrect_clues[this.linking_to_label_index].credit = item.credit
                this.editable_content.incorrect_clues[this.linking_to_label_index].description = item.description
                this.editable_content.incorrect_clues[this.linking_to_label_index].caption = item.caption
                this.editable_content.incorrect_clues[this.linking_to_label_index].url = item.url,
                this.editable_content.incorrect_clues[this.linking_to_label_index].alt = item.alt,
                this.editable_content.incorrect_clues[this.linking_to_label_index].related_media_id = item.id,

                this.linking_to_label_index = 0;
                this.linking_to_incorrect_clue = false;
                this.show_add_related_media_modal = false;
            }
            else{
                this.editable_content.labels = []

                if (this.editable_content.image) {
                    this.editable_content.image = {type: 'image'}
                }

                if (this.editable_content.image) {
                    this.editable_content.image.title = item.title,
                    this.editable_content.image.credit = item.credit
                    this.editable_content.image.description = item.description
                    this.editable_content.image.caption = item.caption
                    this.editable_content.image.src = item.url
                    this.editable_content.image.alt = item.alt
                    this.editable_content.image.related_media_id = item.id
                }

                this.show_add_related_media_modal = false;
            }
        },
        addSBPImageToIncorrectClue(index){

            if (
                this.editable_content.incorrect_clues[index] &&
                this.editable_content.incorrect_clues[index].type == 'text'
            ) {
                this.linking_to_label_index = index;
                this.linking_to_incorrect_clue = true;
                this.show_add_related_media_modal = true;
            }
        },
        addSBPImageToLabel(index){
            if (this.editable_content.labels[index]){
                this.linking_to_label_index = index;
                this.linking_to_label = true;
                this.show_add_related_media_modal = true;
            }
        },
        isMerlinMedia(image) {
            if (!image) {
                return false
            }
            return image.toLowerCase().includes('merlinone')
        },
    }
}
</script>
